import React from 'react';
import { Layout } from './src/components/Layout';
import "@fontsource/space-grotesk";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/inter";
import "./src/styles/global.css";

export function wrapPageElement({ element, props }) {
    return <Layout {...props}>{element}</Layout>
};
